import React from 'react';
import './Home.css';
import { Card } from './Card';

const PaddingTopMap = {
    1: '20px',
    2: '40px',
    3: '80px'
};

const Home = ({
    title,
    description,
    menus,
    subtitle,
    imgUrl,
    textColor,
    color,
    onClick,
    mode
}) => {
    return (
        <div className="home_container_pdc_home">
            <div
                className="home_overlay_pdc_home"
                style={{
                    background: color || 'rgba(0, 0, 0, 0.1)',
                    opacity: 0.5
                }}
            ></div>
            <img src={imgUrl} alt="background" />
            <div
                className="container position-relative"
                style={{
                    paddingTop: PaddingTopMap[mode]
                }}
            >
                <div className="position-relative pb-5">
                    <h2
                        className="home_title_pdc_home"
                        style={{
                            color: textColor ? textColor : '#2c4964',
                            textAlign: mode === '2' ? 'left' : 'center'
                        }}
                    >
                        {title}
                    </h2>
                    <p
                        className="home_subtitle_pdc_home"
                        style={{
                            color: textColor ? textColor : '#444444',
                            textAlign: mode === '2' ? 'left' : 'center'
                        }}
                    >
                        {subtitle}
                    </p>

                    <p
                        className="home_description_pdc_home"
                        style={{
                            color: textColor ? textColor : '#444444',
                            width: mode === '2' ? 'initial' : '100%',
                            maxWidth: mode === '2' ? '800px' : '100%',
                            textAlign: mode === '2' ? 'left' : 'center'
                        }}
                    >
                        {description}
                    </p>
                </div>
                <div className="content row gy-4">
                    <div
                        className={`col-lg-${
                            mode === '2' ? '8' : '12'
                        } d-flex align-items-stretch`}
                    >
                        <div className="d-flex flex-column justify-content-center">
                            <div className="row gy-4">
                                {menus &&
                                    menus.map((menu, index) => {
                                        return (
                                            menu.show && (
                                                <Card
                                                    key={index}
                                                    title={menu.title}
                                                    description={
                                                        menu.description
                                                    }
                                                    onClick={() =>
                                                        onClick(menu)
                                                    }
                                                    page={menu.page}
                                                />
                                            )
                                        );
                                    })}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Home;
